import { Component, Injectable, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Services} from '../servicios.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PropiedadLista } from 'app/models/propiedadLista-model';
import { interval } from 'rxjs';
import { Paquete } from 'app/models/paquete-model';
import { Grupo } from 'app/models/grupo-model';

@Injectable({
    providedIn: 'root'
    })

@Component({
    selector: 'app-components',
    templateUrl: './components.component.html',
    styles: [`
    ngb-progressbar {
        margin-top: 5rem;
    }
    `],
    providers: [Services]
})


export class ComponentsComponent implements OnInit {
    page = 4;
    page1 = 5;
    focus;
    focus1;
    focus2;
    texto;
    date: {year: number, month: number};
    model: NgbDateStruct;
    loading = false;
    backgroundImage = "url('assets/img/portada-4.jpeg')";
    index: number = 0;
    numImages: number = 4;
    imagesLoaded: number = 0;
    imagesUrl = [
        "url('assets/img/portada-1.jpeg')",
        "url('assets/img/portada-2.jpeg')",
        "url('assets/img/portada-3.jpeg')",
        "url('assets/img/portada-4.jpeg')"]

    public Grupos: Array<Grupo> = new Array<Grupo>();

    constructor( private API: Services, private router: Router, private formBuilder: FormBuilder) {}

    isWeekend(date: NgbDateStruct) {
        const d = new Date(date.year, date.month - 1, date.day);
        return d.getDay() === 0 || d.getDay() === 6;
    }

    isDisabled(date: NgbDateStruct, current: {month: number}) {
        return date.month !== current.month;
    }

    getIsMedium(): boolean {
        const w = document.documentElement.clientWidth;
        const breakpoint = 1200;
        const breakpoint2 = 575;
        if (w < breakpoint && w > breakpoint2) {
            return true;
        } else {
            return false;
        }
    }

    ngOnInit() {
        window.location.href = 'https://www.experiencetravel.com.uy'; 
    }

    getBackgroundImage(){
        return this.backgroundImage;
    }

    getBackground(back: string){
        return "url('"+back+"')";
    }
    
    redirect(id: Number){
    console.log(id);
    this.router.navigate(['./destinos/'+id.toString()]);
    }

    public loadExternalScript(url: string) {
        const body = <HTMLDivElement> document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.src = url;
        script.async = true;
        script.defer = true;
        body.appendChild(script);
      }

}
